<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';

const props = defineProps({
  contentAttributes: {
    type: Object,
    default: () => ({}),
  },
});

const { t } = useI18n();

const postContext = computed(() => {
  return props.contentAttributes?.facebookPostContext;
});

const hasPostContext = computed(() => {
  return !!postContext.value;
});

const postMessage = computed(() => {
  return postContext.value?.message || '';
});

const postUrl = computed(() => {
  return postContext.value?.permalinkUrl || '';
});
</script>

<template>
  <div
    v-if="hasPostContext"
    class="flex flex-col gap-1 p-2 mb-2 rounded-lg bg-n-slate-3 border border-n-slate-6"
  >
    <div class="flex items-center gap-2 text-n-slate-11">
      <Icon icon="i-ri-facebook-fill" class="size-3.5 text-[#1877f2]" />
      <span class="text-xs font-medium">
        {{
          t('CONVERSATION.FACEBOOK_POST_CONTEXT.COMMENT_ON_POST') ||
          'Comentario en post'
        }}
      </span>
    </div>
    <p
      v-if="postMessage"
      class="text-sm text-n-slate-12 line-clamp-2"
      :title="postMessage"
    >
      <span class="text-n-slate-10">"</span>
      {{ postMessage }}
      <span class="text-n-slate-10">"</span>
    </p>
    <p v-else class="text-sm text-n-slate-10 italic">
      ({{
        t('CONVERSATION.FACEBOOK_POST_CONTEXT.NO_TEXT') || 'Post sin texto'
      }})
    </p>
    <a
      v-if="postUrl"
      :href="postUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="text-xs text-n-blue-9 hover:text-n-blue-10 hover:underline flex items-center gap-1 mt-1"
    >
      <Icon icon="i-lucide-external-link" class="size-3" />
      {{
        t('CONVERSATION.FACEBOOK_POST_CONTEXT.VIEW_ON_FACEBOOK') ||
        'Ver en Facebook'
      }}
    </a>
  </div>
</template>
